import { render, staticRenderFns } from "./oea-resumen-anual.vue?vue&type=template&id=3922e903&scoped=true"
import script from "./oea-resumen-anual.vue?vue&type=script&lang=js"
export * from "./oea-resumen-anual.vue?vue&type=script&lang=js"
import style0 from "./oea-resumen-anual.vue?vue&type=style&index=0&id=3922e903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3922e903",
  null
  
)

export default component.exports